import { defineMessages } from 'react-intl';

export const scope = 'axionoee.features.stops.components';

export default defineMessages({
    currentShiftFilter: {
        id: `${scope}.label.filters.currentShift`,
        defaultMessage: 'Current shift',
    },
    prevShiftFilter: {
        id: `${scope}.label.filters.prevShift`,
        defaultMessage: 'Prev.shift',
    },
    dayFilter: {
        id: `${scope}.label.filters.24h`,
        defaultMessage: '24h',
    },
    threeDayFilter: {
        id: `${scope}.label.filters.72h`,
        defaultMessage: '72h',
    },
    weekFilter: {
        id: `${scope}.label.filters.week`,
        defaultMessage: 'Week',
    },
    manualFilter: {
        id: `${scope}.label.filters.manual`,
        defaultMessage: 'Manual',
    },
    fromDate: {
        id: `${scope}.label.filters.fromDate`,
        defaultMessage: 'From date',
    },
    toDate: {
        id: `${scope}.label.filters.toDate`,
        defaultMessage: 'To date',
    },
    fromTime: {
        id: `${scope}.label.filters.fromTime`,
        defaultMessage: 'From time',
    },
    toTime: {
        id: `${scope}.label.filters.toTime`,
        defaultMessage: 'To time',
    },
    machinesFilter: {
        id: `${scope}.label.filters.machines`,
        defaultMessage: 'Machines',
    },
    stopFilter: {
        id: `${scope}.label.filters.stop`,
        defaultMessage: 'Stop types',
    },
    allMachines: {
        id: `${scope}.label.filters.allMachines`,
        defaultMessage: 'All machines',
    },
    undefinedStops: {
        id: `${scope}.label.filters.undefinedStops`,
        defaultMessage: 'Undefined stops',
    },
});